(function () {
  function buildSectionUrl(nextUrl, sectionId) {
    const separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
    return `${nextUrl}${separator}section_id=${sectionId}`;
  }

  function initLoadMore(button) {
    const sectionId = button.closest('[id^="vny-collection-grid-"]')?.id.replace('vny-collection-grid-', '');
    if (!sectionId) return;

    button.addEventListener('click', () => {
      const nextUrl = button.getAttribute('data-next-url');
      if (!nextUrl) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Loading…';

      fetch(buildSectionUrl(nextUrl, sectionId))
        .then((response) => response.text())
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = parsed.getElementById('product-grid');
          const currentGrid = document.getElementById('product-grid');

          if (newGrid && currentGrid) {
            Array.from(newGrid.children).forEach((item) => {
              currentGrid.appendChild(item);
            });
          }

          const newPagination = parsed.querySelector('[data-vny-pagination]');
          const newLoadMoreButton = newPagination
            ? newPagination.querySelector('[data-vny-load-more]')
            : null;
          const paginationWrapper = button.closest('[data-vny-pagination]');

          if (newLoadMoreButton && paginationWrapper) {
            button.setAttribute('data-next-url', newLoadMoreButton.getAttribute('data-next-url'));
            button.disabled = false;
            button.textContent = originalText;
          } else if (paginationWrapper) {
            paginationWrapper.remove();
          }

          document.dispatchEvent(new CustomEvent('vny:cards-updated'));
        })
        .catch(() => {
          button.disabled = false;
          button.textContent = originalText;
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-vny-load-more]').forEach(initLoadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
